import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeViewNodeComponent } from './tree-view-node.component';



@NgModule({
  declarations: [
    TreeViewNodeComponent
  ],
  imports: [
    CommonModule,

		RouterModule.forChild([]),
  ],
	exports: [
		TreeViewNodeComponent,
	],
})
export class TreeViewNodeModule { }
